export default __webpack_public_path__ + "static/media/1973.c545b924.jpg";